(ns minorodata.app.config)

(goog-define API_HOST "https://api.dev.kleene.ai")

;; PostHog analytics configuration
(goog-define POSTHOG_PROJECT_TOKEN "")
(goog-define POSTHOG_API_HOST "https://eu.i.posthog.com")
(goog-define ENVIRONMENT "local")

;; Featurebase configuration
(goog-define FEATUREBASE_APP_ID "")

;; How long until a query is considered slow and we should show an additional
;; completion notification?
(def slow-query-duration-s 30)

;; Unleash feature flags configuration
(goog-define UNLEASH_HOST "https://eu.app.unleash-hosted.com/eubb1040/api/frontend")
(goog-define UNLEASH_CLIENT_KEY "da0b0e24b80c6ffdd798a0fdb14e79e516")
(goog-define UNLEASH_APP "default")

(goog-define AUTH_API_HOST "https://api.dev.kleene.ai/gatekeeper")

(goog-define SKIP_DATA_IN_LOGS false)

(goog-define BUILD "app")
(goog-define VERSION "latest")

(def sentry-dsn "https://25f7921c7532e9f14630085aadf93b4c@o4505363962855424.ingest.us.sentry.io/4507270929317888")
